"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCardActionArea = exports.StyledCardActions = exports.StyledCardContent = exports.StyledCardHeader = exports.StyledCard = void 0;
var styles_1 = require("@mui/material/styles");
var Card_1 = __importDefault(require("@mui/material/Card"));
var CardHeader_1 = __importDefault(require("@mui/material/CardHeader"));
var CardContent_1 = __importDefault(require("@mui/material/CardContent"));
var CardActions_1 = __importDefault(require("@mui/material/CardActions"));
var CardActionArea_1 = __importDefault(require("@mui/material/CardActionArea"));
exports.StyledCard = (0, styles_1.styled)(Card_1.default)(function () { return ({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '2.0rem',
}); });
exports.StyledCardHeader = (0, styles_1.styled)(CardHeader_1.default)(function () { return ({
    padding: '2.8rem',
    paddingBottom: '2.8rem',
}); });
exports.StyledCardContent = (0, styles_1.styled)(CardContent_1.default)(function () { return ({
    flex: 1,
    padding: 0,
    paddingLeft: '2.8rem',
    paddingRight: '2.8rem',
    '&:last-child': {
        paddingBottom: '2.8rem',
    },
}); });
exports.StyledCardActions = (0, styles_1.styled)(CardActions_1.default)(function () { return ({
    padding: '2.8rem',
}); });
exports.StyledCardActionArea = (0, styles_1.styled)(CardActionArea_1.default)(function () { return ({
    '&:hover .MuiCardActionArea-focusHighlight': {
        opacity: 0,
    },
}); });
